// Workstation Module - Layer Colors (shared)
// Cores das camadas reutilizaveis em todos os componentes

export const LAYER_COLORS: Record<string, { bg: string; text: string }> = {
  'layer-fundacao': { bg: 'bg-amber-100', text: 'text-amber-800' },
  'layer-infraestrutura': { bg: 'bg-sky-100', text: 'text-sky-800' },
  'layer-sistemas': { bg: 'bg-violet-100', text: 'text-violet-800' },
  'layer-conteudo': { bg: 'bg-emerald-100', text: 'text-emerald-800' },
  'layer-canais': { bg: 'bg-rose-100', text: 'text-rose-800' },
  'layer-ads-growth': { bg: 'bg-orange-100', text: 'text-orange-800' },
}
